import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=30378834&"
import script from "./ButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports